import React from "react";
import {Route} from "react-router-dom";
import AddPosition from "../../pages/ptt/captureGuarantees/addPosition";
import EditPosition from "../../pages/ptt/captureGuarantees/editPosition";
import {ADD_POSITION_ROUTE, EDIT_POSITION_ROUTE} from "../../utils/constants/RoutesConstants";

const CaptureGuaranteesRoutes = () => {
    return (
        <React.Fragment>
            <Route path={ADD_POSITION_ROUTE} component={AddPosition}/>
            <Route path={EDIT_POSITION_ROUTE} component={EditPosition}/>
        </React.Fragment>
    );
};

export default CaptureGuaranteesRoutes;